import { render, staticRenderFns } from "./EditarDescargaActividadModal.vue?vue&type=template&id=1b6203f6&"
import script from "./EditarDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./EditarDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1b6203f6', component.options)
    } else {
      api.reload('1b6203f6', component.options)
    }
    module.hot.accept("./EditarDescargaActividadModal.vue?vue&type=template&id=1b6203f6&", function () {
      api.rerender('1b6203f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/editar/EditarDescargaActividadModal.vue"
export default component.exports